import { createContext, useContext, useState, ReactNode } from 'react';

interface DocumentTitleContextValue {
  customTitle: string | undefined;
  setDocumentTitle: (title: string | undefined) => void;
  clearDocumentTitle: () => void;
}

const DocumentTitleContext = createContext<
  DocumentTitleContextValue | undefined
>(undefined);

export const DocumentTitleProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [customTitle, setCustomTitle] = useState<string | undefined>();

  const setDocumentTitle = (title: string | undefined) => {
    setCustomTitle(title);
  };

  const clearDocumentTitle = () => {
    setCustomTitle(undefined);
  };

  return (
    <DocumentTitleContext.Provider
      value={{ customTitle, setDocumentTitle, clearDocumentTitle }}
    >
      {children}
    </DocumentTitleContext.Provider>
  );
};

export const useDocumentTitleContext = () => {
  const context = useContext(DocumentTitleContext);
  if (!context) {
    throw new Error(
      'useDocumentTitleContext must be used within DocumentTitleProvider',
    );
  }
  return context;
};

export const useOptionalDocumentTitleContext = () => {
  return useContext(DocumentTitleContext);
};
